import React, { useState } from 'react';
import * as authAPI from '@debbie/cortex/dist/api/auth.js';
import { Button, Input } from '../../index.js';
const Reset = (props) => {
    const [username, setUsername] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    // TODO: Lang
    return (React.createElement("div", null,
        React.createElement("form", { onSubmit: async (e) => {
                console.log(e);
                e.preventDefault();
                e.stopPropagation();
                try {
                    await authAPI.initiatePasswordReset(username);
                    props.onReset(username);
                }
                catch (err) {
                    console.error(err);
                    setError(err?.message);
                    setLoading(false);
                }
            } },
            error !== '' ? React.createElement("div", { className: "warning" }, error) : null,
            React.createElement(Input, { placeholder: "E-mail", value: username, onChange: (e) => {
                    setUsername(e.target.value);
                } }),
            React.createElement(Button, { block: true, style: { marginBottom: '10px' }, loading: loading }, "Nulstil"),
            React.createElement(Button, { block: true, onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onCancel();
                }, theme: "secondary" }, "Annuller"))));
};
export default Reset;
//# sourceMappingURL=Reset.js.map